module.exports = __webpack_public_path__ + "media/shop_rules.ad707f8e.mp3";